module.exports = __webpack_public_path__ + "static/uxdesign-998e9d2070211dbfa6f3aeb7a6a7f6ff.png";